import * as api from '../api/customers';
import q from '../query';
export const customerRelatedCasesKey = (customerId) => `customer-relate-cases-${customerId}`;
export const useCustomerRelatedCases = (customerId, casualConsistency) => q.query(customerRelatedCasesKey(customerId), () => customerId
    ? api.getRelatedCases(customerId)
    : null, []);
//# sourceMappingURL=index.js.map